module.exports = __webpack_public_path__ + "media/shared/book-card/images/play-c0a723aba02feb37e87fd9f645d9ea25.svg";